import { render, staticRenderFns } from "./CoreTeamNav.vue?vue&type=template&id=cdef7786&scoped=true&"
import script from "./CoreTeamNav.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreTeamNav.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CoreTeamNav.vue?vue&type=style&index=0&id=cdef7786&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdef7786",
  null
  
)

export default component.exports